import { createTheme } from "@mui/material/styles";

// Shared app theme
export const theme = createTheme({
  palette: {
    primary: {
      main: "#43A047",
    },
  },
});
